import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next";
import MainLinks from "../navlinks/MainLinks";
import Body from "../body/BodyPage";
import {
    MDBAlert, MDBBreadcrumb, MDBBreadcrumbItem, MDBDatatable, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane,
    MDBBtn,
    MDBCol,
    MDBIcon,
    MDBRow,
    MDBScrollspy,
    MDBScrollspyLink
} from "mdb-react-ui-kit";
import { useAdminContext } from "../adminstore/Admin-Context";
import { useLocation, useNavigate } from "react-router";
import AADialByNameEdit from "../editviews/aagroup/AADialByNameEdit";
import { getAADirectorySpecific, getMisc, getSpecificDirectory, updateDirectory } from "../../apiclients/streamsapi_bridge";
import { useForm } from "react-hook-form";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew";
import RemoveToUser from "../../views/popups/misc/RemoveToUser";
import AddToUsers from "../../views/popups/misc/AddToUsers";
import SaveChanges from "./saveCancel";
function DailByDirectoriesSettings() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const { isEdited, setEdited } = useAdminContext();
    const [targetView, setTargetView] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const [assocCallFlows, setAssocCallFlows] = useState([]);
    const [dialDirId, setDialDirId] = useState('');
    const [dialDirName, setDialDirName] = useState('');
    const [aagcode, setaagcode] = useState('');
    const location = useLocation();
    const [directoryInfo, setdirectoryInfo] = useState(
        location.state ? location.state : {}
    );
    const navigate = useNavigate();

    const [dirtype, setdirType] = useState(0);






    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={31}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0">
                                            <MDBBreadcrumb>
                                                <MDBBreadcrumbItem>
                                                    <a
                                                        onClick={(e) => {
                                                            if (isEdited) {
                                                                setTargetView("/phonenumbers");
                                                                setShowWarning(true);
                                                                return;
                                                            }
                                                            navigate("/phonenumbers");
                                                        }}
                                                    >
                                                        <strong>{t("phoneSystem")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    <a
                                                        onClick={(e) => {
                                                            if (isEdited) {
                                                                setTargetView("/dialbydirectoriesLanding");
                                                                setShowWarning(true);
                                                                return;
                                                            }
                                                            navigate("/dialbydirectoriesLanding");
                                                        }}>
                                                        <strong>Dial by Name Directories</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem>
                                                    <a href="">
                                                        <strong>{dialDirName}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>
                                        </h5>


                                        <div className="card-body px-0">
                                            <div className="pb-2">
                                                <h5 className="mt-2 ">
                                                    {dialDirName}
                                                </h5>
                                                <p className="mt-2 text-secondary">
                                                    Directory Type: {dirtype}
                                                </p>
                                            </div>


                                            <AADialByNameEdit
                                                setdirType={setdirType}
                                                setDialDirName={setDialDirName}
                                                directoryInfo={directoryInfo}
                                            />




                                        </div>
                                    </div>
                                </div>
                            </section>


                        </>
                    }
                />


            </>
        </React.Fragment>
    )
}
export default DailByDirectoriesSettings
